import React, { forwardRef } from 'react';
import classes from './CategoryBorderCard.module.scss';
import classNames from 'classnames';
import { WithChildren } from '../../../models/children-props';
import { CategoryColor } from '../../../models/graphql';

export type CategoryBorderCardViewProps = WithChildren<{
  borderColor: CategoryColor;
  borderPosition: 'Left' | 'Top';
  applyCardBorder?: boolean;
  applyCardBackground?: boolean;
}>;

export const CategoryBorderCardView = forwardRef<HTMLDivElement | null, CategoryBorderCardViewProps>(
  (props: CategoryBorderCardViewProps, ref): JSX.Element => {
    const categoryColorClass = classes[`CategoryColor${props.borderColor}`];
    const categoryColorPosition = classes[`CategoryColorPosition${props.borderPosition}`];
    const cardClass = classNames(classes.CategoryBorderCard, categoryColorClass, categoryColorPosition, {
      [classes[`CategoryColor${props.borderColor}FullCardBorder${props.borderPosition}`]]: props.applyCardBorder,
      [classes[`CategoryBackgroundColor${props.borderColor}`]]: props.applyCardBackground
    });

    return (
      <div className={cardClass} ref={ref}>
        {props.children}
      </div>
    );
  }
);

CategoryBorderCardView.displayName = 'CategoryBorderCard';
